export const reviews = [
  {
    name: "Anthony",
    rating: 5,
    text: "C'était super ! Le professeur est sympathique et explique très bien. On apprend vite.",
    source: "Superprof",
  },
  {
    name: "Gonzague",
    rating: 5,
    text: "Louis-Melchior est effectivement un super prof ! Merci à lui pour ce premier cours.",
    source: "Superprof",
  },
  {
    name: "Adelisa",
    rating: 5,
    text: "Louis mérite une excellente note. Il est très à l'écoute, pédagogue et précis dans ses explications. Il donne beaucoup d'aides et de corrections utiles, est patient, motivant et très sympathique. En plus, il crée une excellente ambiance et montre une vraie passion pour la danse.",
    source: "Superprof",
  },
  {
    name: "Alexis",
    rating: 5,
    text: "Il est fantastique, à l'écoute. On l'adore et on vous le recommande à 100%.",
    source: "Superprof",
  },
  {
    name: "Arnaud",
    rating: 5,
    text: "Très pédagogique, super premier contact avec la valse pour nous. Je recommande !",
    source: "Superprof",
  },
  {
    name: "Lucie",
    rating: 5,
    text: "Louis-Melchior est un prof vraiment pédagogue et surtout un passionné qui s'adapte à tous les niveaux. Très ouvert, nous le recommandons à 100%.",
    source: "Recommandation",
  },
  {
    name: "Mike",
    rating: 5,
    text: "Louis-Melchior est ponctuel, communicatif, sympathique et sait comment expliquer et montrer les danses de rock ou de valse à des novices. Ses mots positifs encouragent à oser danser. Merci ! Je recommande 5/5.",
    source: "Recommandation",
  },
  {
    name: "Jean-Baptiste",
    rating: 5,
    text: "Excellent professeur avec des années d'expérience.",
    source: "Recommandation",
  },
  {
    name: "Justine",
    rating: 5,
    text: "Très bon professeur, pédagogue et à l'écoute. Nous avons appris les bases à notre rythme, il ne nous reste plus qu'à pratiquer. Merci beaucoup.",
    source: "Recommandation",
  },
  {
    name: "Arnaud",
    rating: 5,
    text: "Louis-Melchior est très pédagogue, professionnel, souriant. Il a su nous mettre à l'aise rapidement. Je recommande fortement pour ceux ou celles qui veulent découvrir l'univers de la danse.",
    source: "Recommandation",
  },
];
